"use client";

import { useState, useEffect } from "react";

export function useOSShortcut(macKey = "⌘", winKey = "Ctrl") {
  const [key, setKey] = useState(macKey);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const isWindows =
        navigator.platform.toLowerCase().includes("win") ||
        navigator.userAgent.toLowerCase().includes("windows");
      if (isWindows) {
        setKey(winKey);
      }
    }
  }, [macKey, winKey]);

  return key;
}
